import React from "react";
import { StoryblokComponent } from "@storyblok/react";

import { GenericPageSEO } from "@services/Seo/generic-page-seo";
import storyblokInstance from "@services/storyblok-service";
import { ShopifyCollectionService } from "@services/ShopifyCollectionService";
import { ShopifyCollectionDAO } from "@services/ShopifyCollectionDAO";
import { getSeoMetadata } from "@utils/helpers";
import { NavWrapper } from "@components/Global/Nav/NavWrapper/NavWrapper";

const shopifyCollectionService = new ShopifyCollectionService();

const Reviews = props => {
  const { headerStories, pageStories, footerStories, seoData } = props;
  return (
    <>
      <GenericPageSEO
        url={`https://goodlaundry.com/reviews`}
        title={seoData.title || "Reviews by Good People"}
        description={
          seoData.description ||
          "Get reliable and unbiased reviews of Good Laundry eco-friendly products from real people who have tried them."
        }
      />
      <div>
        <NavWrapper>
          {headerStories?.map(blok => (
            <StoryblokComponent blok={blok} key={blok._uid} />
          ))}
        </NavWrapper>
        {pageStories?.map(blok => (
          <StoryblokComponent blok={blok} key={blok._uid} />
        ))}
        {footerStories.map(blok => (
          <StoryblokComponent blok={blok} key={blok._uid} />
        ))}
      </div>
    </>
  );
};

export const getStaticProps = async () => {
  const pageStories = await storyblokInstance.getStory({
    requestString: "cdn/stories/reviews"
  });
  const globalStoryData = await storyblokInstance.getStory({
    requestString: "cdn/stories/global",
    resolveRelations: ["featured-collections.collection_items"]
  });
  const {
    data: {
      story: {
        content: {
          cart_settings: [
            {
              collection_items: [
                {
                  content: { collection_id: cartAddonsCollectionId }
                }
              ]
            }
          ],
          cart_settings,
          global,
          global_footer
        }
      }
    }
  } = globalStoryData;
  const {
    data: {
      story: {
        content: { body, seo }
      }
    }
  } = pageStories;
  const seoData = getSeoMetadata(seo);

  const cartAddonsCollection = await shopifyCollectionService.getCollectionById(
    cartAddonsCollectionId
  );
  return {
    props: {
      headerStories: global,
      footerStories: global_footer,
      pageStories: body,
      cartAddonsCollection: new ShopifyCollectionDAO(cartAddonsCollection)
        .productsList,
      cartSettings: cart_settings,
      seoData
    }
  };
};
export default Reviews;
